import React from 'react';
import './CoreFeatures.css';

import core1 from '../assets/images/core-features.webp';
import follow from '../assets/images/follow-up-tracking1.webp';
import interaction from '../assets/images/interaction-history1.webp';
import opportunity from '../assets/images/opportunity-tracking1.webp';
import portfolio from '../assets/images/portfolio-reviews1.webp';
import task from '../assets/images/task-team-management1.webp';

const CoreFeatures = () => {
  return (
    <section className="cf-section" id="features">
      <div className="cf-container">
        <div className="cf-kicker">
          <span></span>
          CORE FEATURES
        </div>

        <h2 className="cf-title">
          Everything an MFD Needs to
          <span>Nurture & Convert Leads</span>
        </h2>

        <p className="cf-desc">
          Replace spreadsheets, sticky notes, and 5 different tools with one focused CRM
          <br />
          built around your daily MFD workflow.
        </p>

        <div className="cf-grid">
          {/* Image Card */}
          <div className="cf-image-card">
            <img src={core1} alt="MFD Lead Management" />

            <div className="cf-floating-card">
              <div className="cf-floating-icon">
                <img src={task} alt="Lead Management" />
              </div>

              <h4>Lead Management</h4>
              <p>
                Add and manage leads with client details, source, status, and investment
                potential — all in one place.
              </p>
            </div>
          </div>

          {/* Follow-up Tracking */}
          <div className="cf-card cf-red-card cf-follow-card">
            <div className="cf-icon cf-red-icon">
              <img src={follow} alt="Follow-up Tracking" className='sales-mfd-feature-icon' />
            </div>

            <h4>Follow-up Tracking</h4>
            <p>
              Schedule follow-ups, monitor pending activities, and never miss an
              important client conversation again.
            </p>
          </div>

          {/* Interaction History */}
          <div className="cf-card cf-dark-card cf-history-card">
            <div className="cf-icon cf-dark-icon">
              <img src={interaction} alt="Interaction History" className='sales-mfd-feature-icon' />
            </div>

            <h4>Interaction History</h4>
            <p>
              Track calls, meetings, WhatsApp chats, emails, and portfolio reviews with
              complete history and notes.
            </p>
          </div>

          {/* Opportunity Tracking */}
          <div className="cf-card cf-dark-card cf-opportunity-card">
            <div className="cf-icon cf-dark-icon">
              <img src={opportunity} alt="Opportunity Tracking" className='sales-mfd-feature-icon' />
            </div>

            <h4>Opportunity Tracking</h4>
            <p>
              Track SIP & Lumpsum opportunities with stage-wise visibility.
            </p>
          </div>

          {/* Portfolio Reviews */}
          <div className="cf-card cf-red-card cf-portfolio-card">
            <div className="cf-icon cf-red-icon">
              <img src={portfolio} alt="Portfolio Reviews" className='sales-mfd-feature-icon' />
            </div>

            <h4>Portfolio Reviews</h4>
            <p>
              Plan investor reviews & maintain review notes for future action.
            </p>
          </div>

          {/* Task & Team Management */}
          <div className="cf-card cf-gray-card cf-task-card">
            <div className="cf-icon cf-light-icon">
              <img src={task} alt="Task & Team Management" />
            </div>

            <h4>Task & Team Management</h4>
            <p>
              Manage daily activities with priorities & deadlines. Control team access,
              roles & activities from one panel.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreFeatures;